<template>
  <div>
    <!-- 蓝火系统tab -->
    <el-menu
      :default-active="menuIndex"
      class="el-menu-demo"
      mode="horizontal"
      :router="!isNew"
      @select="siteChange"
    >
      <el-menu-item index="base" :route="baseRouter">
        基本信息
        <em class="toggle-btn" v-show="isFibSite && menuIndex === 'base'" @click="toggleMoreInfo">
          <i>{{ !hiddenIs ? '+' : '-' }}</i>
        </em>
      </el-menu-item>
      <el-menu-item
        v-for="link in linkedSites"
        :key="link.sync_type"
        :index="link | siteCode"
        :route="getViewerRouter(link)"
      >
        {{ link | siteName }}
        <em class="toggle-btn" v-if="menuIndex === 'fib' && getSiteNameByCreator(link.creator) === 'fib'" @click="toggleMoreInfo">
          <span>{{ !hiddenIs ? '展开' : '收起' }}</span><i>{{ !hiddenIs ? '+' : '-' }}</i>
        </em>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isEmpty } from '@/utils/utils';
import {
  CREATOR_FIB_TO_TRAINING,
  CREATOR_FIB_TO_JOB,
  CREATOR_TRAINING_TO_FIB,
  CREATOR_TRAINING_TO_JOB,
  CREATOR_JOB_TO_FIB,
  CREATOR_JOB_TO_TRAINING,
  FIB_TO_TRAINING,
  TRAINING_TO_FIB,
  FIB_TO_JOB,
  JOB_TO_FIB,
  TRAINING_TO_JOB,
  JOB_TO_TRAINING,
} from '@/const/sync';

const siteMap = {
  fib: '昆仑系统',
  training: '考培系统',
  job: '求职系统'
};

function getSiteNameByCreator(creator) {
  switch (creator) {
    case CREATOR_FIB_TO_TRAINING:
    case CREATOR_JOB_TO_TRAINING:
      return 'training';
    case CREATOR_FIB_TO_JOB:
    case CREATOR_TRAINING_TO_JOB:
      return 'job';
    case CREATOR_TRAINING_TO_FIB:
    case CREATOR_JOB_TO_FIB:
      return 'fib';
    default:
      return '';
  }
}

export default {
  props: {
    isNew: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      hiddenIs: false,
      activePage: 'base',
      siteMap
    };
  },
  filters: {
    siteName({ creator }) {
      return siteMap[getSiteNameByCreator(creator)] || '';
    },
    siteCode({ creator }) {
      return getSiteNameByCreator(creator) || '';
    }
  },
  computed: {
    ...mapState(['syncInfo', 'menuIndex']),
    linkedSites() {
      return this.syncInfo.relation || [];
    },
    baseRouter() {
      // if (this.readOnly) {
      //   return '';
      // }
      const sites = this.linkedSites;
      let id = this.$route.params.id;
      if (!isEmpty(sites)) {
        id = sites[0].sync_from;
      }
      return { name: `${this.$siteName}_res_editor`, params: { id } };
    },
    syncType() {
      if (this.$siteName === 'fib') {
        return [FIB_TO_TRAINING, FIB_TO_JOB];
      }
      if (this.$siteName === 'job') {
        return [JOB_TO_FIB, JOB_TO_TRAINING];
      }
      if (this.$siteName === 'training') {
        return [TRAINING_TO_FIB, TRAINING_TO_JOB];
      }
    },
  },
  methods: {
    getSiteNameByCreator(creator) {
      return getSiteNameByCreator(creator);
    },
    toggleMoreInfo() {
      this.hiddenIs = !this.hiddenIs;
      this.$emit('update:show-more', this.hiddenIs);
    },
    isFibPage({ creator }) {
      if (creator === CREATOR_TRAINING_TO_FIB) {
        return true;
      }
      if (creator === CREATOR_JOB_TO_FIB) {
        return true;
      }
      return false;
    },
    // eslint-disable-next-line camelcase
    getViewerRouter({ creator, sync_to, sync_from }) {
      const site = getSiteNameByCreator(creator);
      return {
        name: `${site}_res_viewer`,
        params: { id: sync_to, from: sync_from }
      };
    },
    siteChange(index) {
      this.$store.commit('setMenuIndex', index);
    },
    async getRelation() {
      const { from, id } = this.$route.params;
      const { site } = this.$route.meta;
      if (from && isEmpty(this.syncInfo.relation)) {
        const { data } = await this.$http._post({
          url: '/index/sync/read',
          data: { from, types: this.syncType }
        });

        if (!data.some(item => Number(item.sync_to) === Number(id))) {
          this.$message.error('互相关联关系不存在');
          this.$router.push({ name: `${this.$siteName}_res_editor`, params: { id: from } });
          return false;
        }
        this.$store.commit('setSyncInfo', { relation: data });
        this.$nextTick(() => {
          this.siteChange(site);
        });
      }
      // if (this.readOnly) {
      //   this.hiddenIs = true;
      //   this.$emit('update:show-more', this.hiddenIs);
      // }
    }
  },
  mounted() {
    this.getRelation();
  },
};
</script>

<style lang="less" scoped>
em.toggle-btn {
  text-align: center;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  cursor: pointer;
  font-size: 0;
  height: 20px;
  width: 20px;
  line-height: 20px;
  border: 1px solid #3368fa;
  color: #3368fa;
  font-size: 0;
  display: inline-block;
  position: relative;
  top: -1px;
}
em.toggle-btn span,em.toggle-btn i{
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
</style>
